import { render, staticRenderFns } from "./a-company-info.vue?vue&type=template&id=d2f3aeec&"
import script from "./a-company-info.vue?vue&type=script&lang=js&"
export * from "./a-company-info.vue?vue&type=script&lang=js&"
import style0 from "./a-company-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports